import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const FiltersSkeleton: React.FC = () => {
  return (
    <Stack alignItems='stretch' alignContent='center'>
      <Box
        sx={{
          width: '100%',
          flex: 1,
          alignSelf: 'center',
        }}
      >
        <Skeleton variant='rectangular' height={40} sx={{ marginBottom: '30px' }} />
      </Box>
      {[...Array(9)].map((_, i) => (
        <Box
          sx={{
            width: '100%',
            flex: 1,
            alignSelf: 'center',
          }}
          key={i}
        >
          <Skeleton variant='rectangular' height={48} sx={{ marginBottom: '24px' }} />
        </Box>
      ))}
    </Stack>
  );
};

export default FiltersSkeleton;
